import { TweenLite, TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import { Expo } from 'gsap/gsap-core';

class TwoColumns {
	constructor() {
		this.sections = document.querySelectorAll('.two-columns');
		this.sections.forEach((section) => {
			new Section(section);
		});
	}
}

class Section {
	constructor(section) {
		this.section = section;
		this.animate();
		this.lists();
	}

	animate() {
		const title = this.section.querySelectorAll('.title');
		const titleAnimation = TweenMax.staggerFromTo(title, 0.5, { x: -300, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
		const left = this.section.querySelectorAll('.two-columns__column-and-cta');
		const leftAnimation = TweenMax.staggerFromTo(left, 0.5, { x: -300, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
		const right = this.section.querySelectorAll('.column-and-cta--last');
		const rightAnimation = TweenMax.staggerFromTo(right, 0.5, { x: 300, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });

		const timeline = new TimelineLite();
		timeline.add(titleAnimation, 0.1).add(leftAnimation, 0.1).add(rightAnimation, 0.1);

		new ScrollMagic.Scene({
			triggerElement: this.section,
			triggerHook: 0.85,
			offset: 0,
			reverse: false,
		})
			.setTween(timeline)
			.addTo(ScrollMagicController.controller);
	}

	lists() {
		const paragraphs = this.section.querySelectorAll('p');
		paragraphs.forEach((paragraph) => {
			if (paragraph.firstElementChild && paragraph.firstElementChild.innerHTML === '/') {
				paragraph.firstElementChild.style.position = 'absolute';
				paragraph.firstElementChild.style.top = 0;
				paragraph.firstElementChild.style.left = 0;

				paragraph.style.position = 'relative';
				paragraph.style.paddingLeft = '17px';
			}
		});
	}
}

export default TwoColumns;
